import React from "react";
import s from "./orderStepTitle.scss";

export default class OrderStepTitle extends React.Component {
	render() {
		return (
			<div>
				<h1 className={s.title}>{this.props.title}</h1>
				{this.props.subtitle && (
					<div className={s.subtitle}>
						{this.props.subtitle}
						<span className={s.help}>{this.props.helpTooltip}</span>
					</div>
				)}
			</div>
		);
	}
}
